import React, { Component } from "react"
import PropTypes from "prop-types"
import { Button } from "react-bootstrap"
import { browserHistory } from "react-router"

import { Row, Col } from "react-bootstrap"
import moment from "moment"
import FontAwesome from "react-fontawesome"
import Authenticated from "../../../lib/Authenticated"
import SimpleCardRow from "../../fragments/SimpleCardRow"
import SimpleCheckboxRow from "../../fragments/SimpleCheckboxRow"
import CustomBreadCrumb from "../../fragments/CustomBreadCrumb"
import { Link } from "react-router"

class LoanCommissionCard extends Component {

  authenticated = new Authenticated()
  isAdminOrAccountant = this.authenticated.isAdmin() || this.authenticated.isAccountant()

  renderButtonToolbar = id => {

    if(!this.isAdminOrAccountant) return null
    return (
      <div className='align-right'>
        <Button bsStyle="primary" onClick={() => browserHistory.push(`/loancommission/${id}/update`)}>
          <FontAwesome name='pencil' /> Update
        </Button> &nbsp;

        <Button bsStyle="success" onClick={() => browserHistory.push('/loancommission/create')}>
          <FontAwesome name='plus-circle' /> New Commission
        </Button>
      </div>
    )
  }

  getAccountLink = (id, name, glCode) => {

    let link = '-'
    if (id !== null && name != null) {
      link = <Link to={`/glaccounts/${id}/detail`} title="View">
        { `${ name } (${ glCode })` }
      </Link>
    }
    return link
  }

  showItem = item => {

    if(!item) return null

    let { accountToDebit, accountToCredit } = item
    accountToDebit = accountToDebit ? accountToDebit : {}
    accountToCredit = accountToCredit ? accountToCredit : {}

    const { id: glIdD, name: glNameD, glCode: glCodeD } = accountToDebit,

      { id: glIdC, name: glNameC, glCode: glCodeC } = accountToCredit,

      { id, name, description, disabled, calculationTypeFormatted, amountFormatted, createdOn } = item

    return (
      <Col md={8} className='detail-content'>

        <h2 className={disabled ? 'red' : 'blue' }>{ name }
          { disabled ? <span> <small className="red">(disabled)</small></span> : '' }
        </h2>

        <SimpleCardRow name='Account to debit' value={
          this.getAccountLink(glIdD, glNameD, glCodeD) } />
        <SimpleCardRow name='Account to credit' value={
          this.getAccountLink(glIdC, glNameC, glCodeC) } />
        <SimpleCardRow name='Calculation type' value={ calculationTypeFormatted } />
        <SimpleCardRow name='Amount' value={ amountFormatted } />
        <SimpleCheckboxRow text='Disabled' value={ disabled } />
        <SimpleCardRow name='Description' value={ description ? description : '-' } />
        <SimpleCardRow name='Created On' value={ createdOn ? moment(createdOn).format('lll') : '' }
          className='gray font-size-13' />

        { this.renderButtonToolbar(id) }

      </Col>
    )
  }

  render() {

    const { loanCommission } = this.props,
    dataBreadCrumbs = [
      { url: '/accounting', title: 'Accounting' },
      { url: '/loancommission', title: 'Loan commission' }
    ]

    return (
      <div>
        <CustomBreadCrumb activeText={ loanCommission.name } data={ dataBreadCrumbs } />
        <Row>
          <Col md={4} className="align-center">
            <FontAwesome name="tags" size="3x" className="detail-icon" />
          </Col>

          { this.showItem(loanCommission) }
        </Row>
      </div>
    )
  }
}

LoanCommissionCard.propTypes = {
  loanCommission: PropTypes.object.isRequired,
}

export default LoanCommissionCard



// WEBPACK FOOTER //
// ./src/components/Accounting/LoanCommission/Card.js